import React from "react";
import styles from "./scss/noteview.module.scss";

import { chats, chatwindowDetails, initialStateModel } from "../../../models/model";
import { useSelector } from "react-redux";
import { ChatService } from "../../../base/chatService";
export default function NoteViewRight(props:any) {
  const chatWindow: chatwindowDetails = useSelector((state: initialStateModel) => state.chatWindowReducer);
  const chat_reducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  const Close=()=>{
    if(window.location.pathname === '/contacts' && !chatWindow.isMySpace){
      props.handleToggle();
    }
    else if (chatWindow.isMySpace) {
      chat_reducer.isWindowSlide && ChatService.rightSideToogle();
    }
    else {
      props.chatSideWindow(true,"",{})
    }
  
  };
  
  return (
    <>

      <div className={styles.notesmain}>
        <div className={styles.rightbartop}>
          <div className={styles.lefts}>
            {props.noteData.summary}
          </div>
          <div className={styles.rights} onClick={Close}>
            <span className="icon_close"></span>
          </div>
        </div>

        <div className={`${styles.rightbarbottom} ${styles.noteseditScroll}`}>
          {props.noteData.description}
          {/* <p>Initially we start with some basic basic functionalities…</p>
          <h4>Functionality suggestions:</h4>
          <ul>
            <li>Scheduling a meeting</li>
            <li>Share meeting</li>
          </ul>
          <img src={notesimg} alt=""/>
          <p>Initially we start with some basic basic functionalities…</p> */}
        </div>
      </div>

    </>
  );
};

